"use strict";Object.defineProperty(exports, "__esModule", {value: true});











let listeners = {}

const getListenersByType = (type) => {
  const wildcardListeners = listeners['*']
  const specificListeners = listeners[type]
  if (!wildcardListeners) return specificListeners
  if (!specificListeners) return wildcardListeners
  return specificListeners.concat(wildcardListeners)
}

 const busMiddleware = store => next => action => {
  const typedAction = action 
  const type = typedAction.type

  // run reducers before bus middleware
  const result = next(action)

  const handlers = getListenersByType(type)
  if (handlers) {
    // Snapshot the once listeners before running handlers, so a once
    // listener a handler registers during this dispatch survives until the
    // next one.
    const fired = new Set(handlers.filter(obj => obj.howManyTimes === 'once'))
    const state = store.getState()
    handlers.forEach((obj) => obj.handler(typedAction, state))

    // Drop the once listeners that just fired from the lists they came from.
    // `handlers` can be a copy (specific + wildcard listeners), so removing
    // them from it, or looking them up by type alone, is not enough.
    if (fired.size > 0) {
      [type, '*'].forEach(name => {
        const list = listeners[name]
        if (!list) return
        for (let i = list.length - 1; i >= 0; i--) {
          if (fired.has(list[i])) list.splice(i, 1)
        }
      })
    }
  }
  // Callers read the dispatched action back (a send's FAILURE, useSendFile).
  return result
}; exports.busMiddleware = busMiddleware

const bus = {
  on: (name, handler, type = 'on') => {
    if (listeners[name] == null) listeners[name] = []
    listeners[name].push({ handler, howManyTimes: type })
  },

  once: (name, handler) => bus.on(name, handler, 'once'),

  off: (name, handler) => {
    if (name == null) {
      listeners = {}
      return
    }

    if (handler == null) {
      delete listeners[name]
      return
    }

    const relevantListeners = listeners[name]
    if (relevantListeners) {
      // -1 when the handler isn't registered: then nothing is removed.
      const index = relevantListeners.findIndex(l => l.handler === handler)
      if (index >= 0) relevantListeners.splice(index, 1)
    }
  },
}


 const trigger = () => null; exports.trigger = trigger

exports. default = bus
